module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/isBoolean.js
// module id = 309
// module chunks = 1